<div class="container-fluid blotter_top_interaction_bar" #topMenu *ngIf="enableToolbar">
  <div class="blotter_titlebar_interaction">
    <div class="blotter_filter_bar_container">
      <bfx-trade-type-dropdown [(ngModel)]="tradeTypeFilter"></bfx-trade-type-dropdown>
      <div class="filter-bar-separator"></div>
      <div
        class="bfx-blotter-filter-bar blotter_filter_bar"
        [blotterInstance]="blotterInstance"
      ></div>
    </div>
    <div class="bfx-blotter-tools-container">
      <bfx-quick-search
        class="bfx-quick-search"
        [(ngModel)]="searchValue"
        (ngModelChange)="onChangeSearchValue()"
      ></bfx-quick-search>
      <div class="blotter_titlebar_interaction_right">
        <bfx-icon-button
          size="sm"
          iconClass="icon_ion_filter_filled"
          (action)="showFilterManager($event)"
          title="Filter Manager"
        ></bfx-icon-button>
        <bfx-icon-button
          size="sm"
          iconClass="icon_ion_settings_filled"
          (action)="settingsMenu.toggle($event)"
          title="Settings"
        ></bfx-icon-button>
        <bfx-blotter-settings-menu #settingsMenu></bfx-blotter-settings-menu>
      </div>
    </div>
  </div>
</div>
<div
  class="container-fluid blotter_top_interaction_bar"
  #topMenu
  *ngIf="embeddedTableModeSearchToggle"
>
  <div class="blotter_titlebar_interaction">
    <div class="blotter_filter_bar_container"></div>
    <div class="bfx-blotter-tools-container">
      <bfx-quick-search
        class="bfx-quick-search"
        [(ngModel)]="searchValue"
        (ngModelChange)="onChangeSearchValue()"
      ></bfx-quick-search>
    </div>
  </div>
</div>
<div class="blotter_table_target" #tableTarget>
  <ag-grid-angular
    style="width: 100%; height: 100%"
    class="ag-bcdfx pinned-border"
    [columnDefs]="columnDefs"
    [gridOptions]="gridOptions"
    [toolPanelSuppressSideButtons]="true"
    [frameworkComponents]="frameworkComponents"
    multiSortKey="ctrl"
    enableColResize
    enableSorting
    rowHeight="22"
    (mouseup)="onMouseUp($event)"
    (contextmenu)="handleClick($event)"
  >
  </ag-grid-angular>
</div>

<div *ngIf="windowUndocked" class="footer">
  <div class="message" fxLayout="row" [innerHTML]="vwapFooterText"></div>
</div>

<bfx-risk-trade-context-menu
  *ngIf="!embeddedTableMode"
  [currentLadderBlotter]="blotterInstance"
  bfxElementOnBody
></bfx-risk-trade-context-menu>
<bfx-blotter-column-selector
  [currentLadderBlotter]="blotterInstance"
  bfxElementOnBody
></bfx-blotter-column-selector>
